import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Ui } from "@silvertours/front-shared";
import { LoginForm } from "./LoginForm";
import { useLogin } from "./LoginState";
import { Footer } from "./Footer";
export var LoginModal = function(param) {
    var translations = param.translations;
    var ref = useLogin(), showLogin = ref.showLogin, setShowLogin = ref.setShowLogin;
    return /*#__PURE__*/ _jsx(Ui.Overlay, {
        footerContent: /*#__PURE__*/ _jsx(Footer, {
            isLoggedIn: false,
            translations: translations
        }),
        open: showLogin,
        onClose: function() {
            return setShowLogin(false);
        },
        children: /*#__PURE__*/ _jsx(LoginForm, {
            translations: translations,
            withinModal: true
        })
    });
};
